import React, { useState, useEffect } from 'react';
import "./sportsevents.css";
import Sidebar from '../../../Components/Sidebar/Sidebar';
import roadrail1 from "../../../Assets/sports-events.jpg";
import { Link } from 'react-router';
import roadrail2 from "../../../Assets/sound-barrier-india.webp";
import roadrail3 from "../../../Assets/sports/spacious-sports.avif";
import roadrail4 from "../../../Assets/sound-barrier-manufacturer.webp";
import roadrail5 from "../../../Assets/sports/sports1.jpg";
import roadrail6 from "../../../Assets/sports/sports2.jpg";
import roadrail7 from "../../../Assets/sports/sports3.jpg";
import roadrail8 from "../../../Assets/sports/sports4.avif";
import roadrail9 from "../../../Assets/sports/sports5.jpg";
import roadrail10 from "../../../Assets/sports/sports6.jpg";
import roadrail11 from "../../../Assets/sports/sports7.jpg";
import HNavbar from '../../../Components/Navbar/HNavbar';
import MFooter from '../../../Components/Main-Footer/MFooter';

function SportsEvents() {
    const [showTopBtn, setShowTopBtn] = useState(false);

    const handleClick = () => {
        const name = document.getElementById('name').value.trim();
        const mail = document.getElementById('mail').value.trim();
        const phone = document.getElementById('phone').value.trim();
        const message = document.getElementById('message').value.trim();

        const subject = `New message from ${name}`
        const body = `Name: ${name}%0AEmail: ${mail}%0APhone: ${phone}%0A%0AMessage:%0A${message}`;
        const mailtoLink = `mailto:mail@acousticalsurfaces.in?subject=${encodeURIComponent(subject)}&body=${body}`;

        window.open(mailtoLink, '_blank');

        document.getElementById('name').value = '';
        document.getElementById('mail').value = '';
        document.getElementById('phone').value = '';
        document.getElementById('message').value = '';
    }
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 400) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        };
        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    useEffect(() => {
        const animatedElements = document.querySelectorAll('.sports-header,.sports-header1,.sports-header2,.sports-header3,.sports-header4,.sports-header5,.sports-header6');

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate');
                } else {
                    entry.target.classList.remove('animate');
                }
            });
        }, { threshold: 0.3 });

        animatedElements.forEach(el => observer.observe(el));

        return () => {
            animatedElements.forEach(el => observer.unobserve(el));
        };
    }, []);
    return (
        <>
        <HNavbar />
            <section id='sports-events' className='home-sports'>
                <div className='container p-0'>
                    <Sidebar />
                    <div className='row main-sports-events'>
                        <div className='col-12 col-md-6 d-flex justify-content-center align-items-center p-3'>
                            <div className='image-wrapper'>
                                <img className='img-fluid sports-events-home-img' src={roadrail1} alt="sports-events" />
                            </div>
                        </div>
                        <div className='col-12 col-md-6 d-flex flex-column justify-content-center align-items-start text-white'>
                            <h1 className='sports-header'>Sports and Events Auditorium Noise Control Solutions | Sound Barrier</h1>
                            <p className='white-para'>Sports arenas and event auditoriums generate high noise levels from audience cheering, sound systems, live performances, and announcements. Without proper noise control, this sound can disturb nearby residential and commercial areas.</p>
                            <p className='white-para'><b>Sound Barrier Manufacture</b> provides professional sound barrier noise control solutions for sports complexes and event auditoriums to prevent outside public disturbance.</p>
                            <p className='white-para'>Our high-performance sound barrier blankets and acoustic systems are designed to control crowd noise and reduce sound transmission beyond the venue boundary.</p>
                            <Link to="/contact"><button className='btn' type="button">Contact us</button></Link>
                        </div>
                    </div>
                </div>
            </section >

            <section id='sports-events'>
                <div className='container noice-control mt-4'>
                    <h1 className='sports-header1'>Why Noise Control is Important for Sports and Event Auditoriums</h1>
                    <div className='row'>
                        <div className='col-sm-12 col-md-6 d-flex justify-content-center'>
                            <img className='img-fluid' src={roadrail2} alt="sports-events" style={{ height: "500px" }} />
                        </div>
                        <div className='col-sm-12 col-md-6 d-flex flex-column align-items-start justify-content-center'>
                            <p>Large gatherings and events can produce extreme sound levels. Proper noise control is essential to:</p>
                            <ul className='list'>
                                <li>Prevent disturbance to nearby residential areas</li>
                                <li>Avoid public complaints</li>
                                <li>Meet environmental noise regulations</li>
                                <li>Protect the reputation of the venue</li>
                                <li>Ensure safe and controlled sound management</li>
                            </ul>
                        </div>
                    </div>
                    <p>Installing effective sound barriers helps maintain balance between entertainment and community comfort.</p>

                    <h1 className='sports-header2' style={{ marginTop: "10px" }}>Our Sports and Event Sound Barrier Solutions</h1>
                    <p>Sound Barrier Manufacture supplies heavy-duty sound barrier systems suitable for indoor and outdoor event venues.</p>
                    <div className='row mt-5'>
                        <div className='col-sm-12 col-md-6'>
                            <h5>Key Features:</h5>
                            <ul className='list'>
                                <li>High STC-rated sound barrier material</li>
                                <li>Durable and weather-resistant outer layer</li>
                                <li>Suitable for temporary or permanent installation</li>
                                <li>Fire-retardant options available</li>
                                <li>Easy mounting on fencing, barricades, and structures</li>
                                <li>Reusable and long-lasting performance</li>
                            </ul>
                            <p>Our acoustic sound blankets help reduce noise leakage from stadiums and auditoriums.</p>
                        </div>
                        <div className='col-sm-12 col-md-6'>
                            <img className='img-fluid' src={roadrail3} alt="sports-events" style={{ height: "400px" }} />
                        </div>
                    </div>

                    <h1 className='sports-header3' style={{ marginTop: "30px" }}>Benefits of Using Sound Barriers in Auditoriums</h1>
                    <div className='row'>
                        <div className='col-sm-12 col-md-6'>
                            <img className='img-fluid' src={roadrail4} alt="sports-events" />
                        </div>
                        <div className='col-sm-12 col-md-6 d-flex flex-column align-items-center justify-content-center'>
                            <p>Using sports and event noise control systems helps:</p>
                            <ul className='list'>
                                <li>Reduce audience noise transmission</li>
                                <li>Protect surrounding communities</li>
                                <li>Improve event compliance with local regulations</li>
                                <li>Enhance sound management inside the venue</li>
                                <li>Maintain a positive public image</li>
                            </ul>
                        </div>
                    </div>
                    <h1 className='sports-header4' style={{ marginTop: "20px" }}>Applications in Sports and Event Venues</h1>
                    <h4>Our noise control solutions are ideal for:</h4>
                    <div className='row'>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={roadrail5} alt="Indoor sports arenas" />
                            <p>Indoor sports arenas</p>
                        </div>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={roadrail6} alt="Outdoor stadiums" />
                            <p>Outdoor stadiums</p>
                        </div>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={roadrail7} alt="Concert venues" />
                            <p>Concert venues</p>
                        </div>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={roadrail8} alt="Exhibition centers" />
                            <p>Exhibition centers</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-sm-4 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={roadrail9} alt="Cultural event auditoriums" />
                            <p>Cultural event auditoriums</p>
                        </div>
                        <div className='col-sm-4 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={roadrail10} alt="Temporary event stages" />
                            <p>Temporary event stages</p>
                        </div>
                        <div className='col-sm-4 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={roadrail11} alt="Public gathering zones" />
                            <p>Public gathering zones</p>
                        </div>
                    </div>
                </div >
            </section>
            <section id='sports-events' className='call'>
                <div className='container'>
                    <h1 className='sports-header5'>Why Choose Us?</h1>

                    <ul className='sports-list white-para'>
                        <li>Experienced acoustic solution provider</li>
                        <li>High-performance event sound barrier systems</li>
                        <li>Custom size and thickness options</li>
                        <li>Quick supply and project support</li>
                        <li>Cost-effective outdoor and indoor noise control solutions</li>
                    </ul>
                    <p className='white-para'>We provide reliable sound barrier systems designed to control audience noise and protect nearby public areas.</p>

                    <h1 className='sports-header6'>Contact Us for Sports and Event Auditorium Noise Control Solutions</h1>
                    <div className='row'>
                        <div className='col-sm-12 col-md-6'>
                            <p className='white-para'>Looking for professional noise control solutions for your sports or event auditorium?</p>
                            <p className='white-para'>Sound Barrier Manufacture delivers customized sound barrier systems to reduce public disturbance and improve overall sound management.</p>
                            <p className='white-para'>Contact us today for expert consultation and venue-specific noise control solutions.</p>
                        </div>
                        <div className='col-sm-12 col-md-6'>
                            <div className="row">
                                <div className="col-sm-12 col-md-4 mb-3">
                                    <input
                                        type="text"
                                        name="name"
                                        id="name"
                                        className="form-control"
                                        placeholder="Name *"
                                    />
                                </div>
                                <div className="col-sm-12 col-md-4 mb-3">
                                    <input
                                        type="email"
                                        name="mail"
                                        id="mail"
                                        className="form-control"
                                        placeholder="Email *"
                                    />
                                </div>
                                <div className="col-sm-12 col-md-4 mb-3">
                                    <input
                                        type="text"
                                        name="phone"
                                        id="phone"
                                        className="form-control"
                                        placeholder="Phone *"
                                    />
                                </div>
                                <div className="col-12 mb-3">
                                    <textarea
                                        rows={4}
                                        id="message"
                                        className="form-control"
                                        placeholder="Message *"
                                    ></textarea>
                                </div>
                                <div className="col-12">
                                    <button
                                        className="btn"
                                        type="button"
                                        onClick={handleClick}
                                    >
                                        SEND
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {showTopBtn && (
                <button className='scroll-to-top'
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                > ↑ </button>
            )
            }
            <MFooter />
        </>
    )
}
export default SportsEvents